module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Tpwm90/tc-custom/9781617453373.jpg?1729379497727",
      "alt": "This image is the cover for the book No Scrap Left Behind"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No Scrap Left Behind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Make use of those small pieces . . . The peek into [the author’s] design process (including some ideas that didn't quite work) is fascinating.” —"), _c('i', [_vm._v("Library Journal")]), _vm._v(" (starred review)")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Rescue your fabric scraps—even the smallest pieces—with these sixteen satisfying quilts and projects. Sew modern quilts for everyday use that will help you return to the roots of quiltmaking, with projects designed to help you use up every last scrap."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Learn sorting and storage tips to help you plan your next quilt, with projects categorized by type of scrap—squares, strings, triangles, or little snippets. With this extensively illustrated guide from teacher and designer Amanda Jean Nyberg, you’ll never look at scraps the same way again!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Fabulous . . . Even those experienced in working with scraps are likely to learn something from her insights. Highly recommended.” ―"), _c('i', [_vm._v("Homespun")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Jean Nyberg\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0